// Deluxe Room
import deluxe_room_01 from "../Images/Deluxe-Room/Deluxe-Room.png";
import deluxe_room_02 from "../Images/Deluxe-Room/Deluxe-Room-02.jpg";
import deluxe_room_03 from "../Images/Deluxe-Room/Deluxe-Room-03.jpg";

import one from '../Images/onea.jpeg'
import two from '../Images/twoa.jpeg'
import three from '../Images/threea.jpeg'
import four from '../Images/foura.jpeg'
import five from '../Images/fivea.jpeg'
import six from '../Images/sixa.jpeg'
import seven from '../Images/sevena.jpeg'
import eight from '../Images/eighta.jpeg'
import nine from '../Images/ninea.jpeg'


// Super Deluxe Room
import Super_Deluxe_Room_01 from "../Images/Super-Deluxe-Room/Super-Deluxe-Room-01.jpg";
import Super_Deluxe_Room_02 from "../Images/Super-Deluxe-Room/Super-Deluxe-Room-02.jpg";
import Super_Deluxe_Room_03 from "../Images/Super-Deluxe-Room/Super-Deluxe-Room-03.jpg";
import Super_Deluxe_Room_04 from "../Images/Super-Deluxe-Room/Super-Deluxe-Room-04.jpg";
import Super_Deluxe_Room_05 from "../Images/Super-Deluxe-Room/Super-Deluxe-Room-05.jpg";

// Sunset Room
import Sunset_Room_01 from "../Images/Sunset-Room/Sunset-Room-01.jpg";
import Sunset_Room_02 from "../Images/Sunset-Room/Sunset-Room-02.jpg";
import Sunset_Room_03 from "../Images/Sunset-Room/Sunset-Room-03.jpg";
import Sunset_Room_04 from "../Images/Sunset-Room/Sunset-Room-04.jpg";
import Sunset_Room_05 from "../Images/Sunset-Room/Sunset-Room-05.jpg";
import Sunset_Room_06 from "../Images/Sunset-Room/Sunset-Room-06.jpg";
import Sunset_Room_07 from "../Images/Sunset-Room/Sunset-Room-07.jpg";

// Villa Room
import Villa_Room_01 from "../Images/Villa-Room/Villa-Room-01.jpg";
import Villa_Room_02 from "../Images/Villa-Room/Villa-Room-02.jpg";
import Villa_Room_03 from "../Images/Villa-Room/Villa-Room-03.jpg";
import Villa_Room_04 from "../Images/Villa-Room/Villa-Room-04.jpg";
import Villa_Room_05 from "../Images/Villa-Room/Villa-Room-05.jpg";
const RoomData = [
    {
        room_id: "1",
        slug:"/premium-deluxe-cottage-in-Neral",
        roomName: "Premium Deluxe Cottage",
        roomImageData: [
            {
                roomImage:one,
            },
            {
                roomImage:two,
            },
            {
                roomImage:three,
            },
            ,
            {
                roomImage:four,
            },
            {
                roomImage:five,
            },
        ],
        roomPrice: "3,000 - 3,800",
        roomBed: "1",
        roomMax_Guests: "2",
        roomShort_Des:['Experience unparalleled luxury and comfort at our Premium Deluxe Cottage in Neral. Nestled in the serene landscapes of the Western Ghats, this cottage offers a perfect blend of modern amenities and natural beauty. The spacious interior is designed with sophisticated decor, featuring a king-sized bed with plush linens, a cozy sitting area, and large windows that offer stunning views of the surrounding hills and lush greenery.',
            'The cottage is equipped with state-of-the-art facilities, including air conditioning, high-speed internet, a flat-screen TV, and an elegant en-suite bathroom with premium toiletries. A private outdoor seating area allows you to unwind and enjoy the cool breeze and scenic beauty.',
            "Ideal for couples or small families, the Premium Deluxe Cottage offers a tranquil retreat with exclusive services like personalized room service, curated dining options, and easy access to resort amenities such as the swimming pool. Whether you're seeking relaxation or an adventurous getaway, this cottage promises a memorable stay in the heart of Neral."
        ],
    },
    {
        room_id: "2",
        slug:"/dormitory-in-Neral",
        roomName: "Dormitory",
        roomImageData: [
            {
                roomImage:two,
            },
            {
                roomImage:three,
            },
            {
                roomImage:four,
            },
            ,
            {
                roomImage:five,
            },
            {
                roomImage:six,
            },
        ],
        roomPrice: "2,300 - 10,000",
        roomBed: "1",
        roomMax_Guests: "2",
        roomShort_Des:['Experience unparalleled luxury and comfort at our Dormitory in Neral. Nestled in the serene landscapes of the Western Ghats, this cottage offers a perfect blend of modern amenities and natural beauty. The spacious interior is designed with sophisticated decor, featuring a king-sized bed with plush linens, a cozy sitting area, and large windows that offer stunning views of the surrounding hills and lush greenery.',
            'The cottage is equipped with state-of-the-art facilities, including air conditioning, high-speed internet, a flat-screen TV, and an elegant en-suite bathroom with premium toiletries. A private outdoor seating area allows you to unwind and enjoy the cool breeze and scenic beauty.',
            "Ideal for couples or small families, the Dormitory offers a tranquil retreat with exclusive services like personalized room service, curated dining options, and easy access to resort amenities such as the swimming pool. Whether you're seeking relaxation or an adventurous getaway, this cottage promises a memorable stay in the heart of Neral."
        ],
    },
    {
        room_id: "3",
        slug:"/suit-cottage-in-Neral",
        roomName: "Suit Cottage",
        roomImageData: [
            {
                roomImage:three,
            },
            {
                roomImage:four,
            },
            {
                roomImage:five,
            },
            ,
            {
                roomImage:six,
            },
            {
                roomImage:seven,
            },
        ],
        roomPrice: "3,500 - 5500",
        roomBed: "1",
        roomMax_Guests: "2",
        roomShort_Des:['Experience unparalleled luxury and comfort at our Suit Cottage in Neral. Nestled in the serene landscapes of the Western Ghats, this cottage offers a perfect blend of modern amenities and natural beauty. The spacious interior is designed with sophisticated decor, featuring a king-sized bed with plush linens, a cozy sitting area, and large windows that offer stunning views of the surrounding hills and lush greenery.',
            'The cottage is equipped with state-of-the-art facilities, including air conditioning, high-speed internet, a flat-screen TV, and an elegant en-suite bathroom with premium toiletries. A private outdoor seating area allows you to unwind and enjoy the cool breeze and scenic beauty.',
            "Ideal for couples or small families, the Suit Cottage offers a tranquil retreat with exclusive services like personalized room service, curated dining options, and easy access to resort amenities such as the swimming pool. Whether you're seeking relaxation or an adventurous getaway, this cottage promises a memorable stay in the heart of Neral."
        ],
    },
    {
        room_id: "4",
        slug:"/standard-room-in-Neral",
        roomName: "Standard Room",
        roomImageData: [
            {
                roomImage:four,
            },
            {
                roomImage:five,
            },
            {
                roomImage:six,
            },
            ,
            {
                roomImage:seven,
            },
            {
                roomImage:eight,
            },
        ],
        roomPrice: "2250 - 2500",
        roomBed: "1",
        roomMax_Guests: "2",
        roomShort_Des:['Experience unparalleled luxury and comfort at our Standard Room in Neral. Nestled in the serene landscapes of the Western Ghats, this cottage offers a perfect blend of modern amenities and natural beauty. The spacious interior is designed with sophisticated decor, featuring a king-sized bed with plush linens, a cozy sitting area, and large windows that offer stunning views of the surrounding hills and lush greenery.',
            'The cottage is equipped with state-of-the-art facilities, including air conditioning, high-speed internet, a flat-screen TV, and an elegant en-suite bathroom with premium toiletries. A private outdoor seating area allows you to unwind and enjoy the cool breeze and scenic beauty.',
            "Ideal for couples or small families, the Standard Room offers a tranquil retreat with exclusive services like personalized room service, curated dining options, and easy access to resort amenities such as the swimming pool. Whether you're seeking relaxation or an adventurous getaway, this cottage promises a memorable stay in the heart of Neral."
        ],
    },
    {
        room_id: "5",
        slug:"/studio-room-in-Neral",
        roomName: "Studio Room",
        roomImageData: [
            {
                roomImage:five,
            },
            {
                roomImage:six,
            },
            {
                roomImage:seven,
            },
            ,
            {
                roomImage:eight,
            },
            {
                roomImage:nine,
            },
        ],
        roomPrice: "2,500 - 2500",
        roomBed: "1",
        roomMax_Guests: "2",
        roomShort_Des:['Experience unparalleled luxury and comfort at our Studio Room in Neral. Nestled in the serene landscapes of the Western Ghats, this cottage offers a perfect blend of modern amenities and natural beauty. The spacious interior is designed with sophisticated decor, featuring a king-sized bed with plush linens, a cozy sitting area, and large windows that offer stunning views of the surrounding hills and lush greenery.',
            'The cottage is equipped with state-of-the-art facilities, including air conditioning, high-speed internet, a flat-screen TV, and an elegant en-suite bathroom with premium toiletries. A private outdoor seating area allows you to unwind and enjoy the cool breeze and scenic beauty.',
            "Ideal for couples or small families, the Studio Room offers a tranquil retreat with exclusive services like personalized room service, curated dining options, and easy access to resort amenities such as the swimming pool. Whether you're seeking relaxation or an adventurous getaway, this cottage promises a memorable stay in the heart of Neral."
        ],
    },
    {
        room_id: "6",
        slug:"/deluxe-cottage-in-Neral",
        roomName: "Deluxe Cottage",
        roomImageData: [
            {
                roomImage:six,
            },
            {
                roomImage:seven,
            },
            {
                roomImage:eight,
            },
            ,
            {
                roomImage:nine,
            },
            {
                roomImage:one,
            },
        ],
        roomPrice: "3,000 - 3800",
        roomBed: "1",
        roomMax_Guests: "2",
        roomShort_Des:['Experience unparalleled luxury and comfort at our Deluxe Cottage in Neral. Nestled in the serene landscapes of the Western Ghats, this cottage offers a perfect blend of modern amenities and natural beauty. The spacious interior is designed with sophisticated decor, featuring a king-sized bed with plush linens, a cozy sitting area, and large windows that offer stunning views of the surrounding hills and lush greenery.',
            'The cottage is equipped with state-of-the-art facilities, including air conditioning, high-speed internet, a flat-screen TV, and an elegant en-suite bathroom with toiletries. A private outdoor seating area allows you to unwind and enjoy the cool breeze and scenic beauty.',
            "Ideal for couples or small families, the Premium Deluxe Cottage offers a tranquil retreat with exclusive services like personalized room service, curated dining options, and easy access to resort amenities such as the swimming pool. Whether you're seeking relaxation or an adventurous getaway, this cottage promises a memorable stay in the heart of Neral."
        ],
    },
    {
        room_id: "7",
        slug:"/family-executive-in-Neral",
        roomName: "Family Executive",
        roomImageData: [
            {
                roomImage:seven,
            },
            {
                roomImage:eight,
            },
            {
                roomImage:nine,
            },
            ,
            {
                roomImage:one,
            },
            {
                roomImage:two,
            },
        ],
        roomPrice: "3,500",
        roomBed: "1",
        roomMax_Guests: "2",
        roomShort_Des:['Experience unparalleled luxury and comfort at our Family Executive in Neral. Nestled in the serene landscapes of the Western Ghats, this cottage offers a perfect blend of modern amenities and natural beauty. The spacious interior is designed with sophisticated decor, featuring a king-sized bed with plush linens, a cozy sitting area, and large windows that offer stunning views of the surrounding hills and lush greenery.',
            'The cottage is equipped with state-of-the-art facilities, including air conditioning, high-speed internet, a flat-screen TV, and an elegant en-suite bathroom with premium toiletries. A private outdoor seating area allows you to unwind and enjoy the cool breeze and scenic beauty.',
            "Ideal for couples or small families, the Family Executive offers a tranquil retreat with exclusive services like personalized room service, curated dining options, and easy access to resort amenities such as the swimming pool. Whether you're seeking relaxation or an adventurous getaway, this cottage promises a memorable stay in the heart of Neral."
        ],
    },
    // {
    //     room_id: 2,
    //     slug:"/RoomDetailsPage/2",
    //     roomName: "Super Deluxe Room",
    //    roomImageData: [
    //         {
    //             roomImage:Super_Deluxe_Room_01,
    //         },
    //         {
    //             roomImage:Super_Deluxe_Room_02,
    //         },
    //         {
    //             roomImage:Super_Deluxe_Room_03,
    //         },
    //         {
    //             roomImage:Super_Deluxe_Room_04,
    //         },
    //         {
    //             roomImage:Super_Deluxe_Room_05,
    //         },
    //     ],
    //     roomPrice: "4,000",
    //     roomBed: "2",
    //     roomMax_Guests: "4",
    //     roomShort_Des:"Super Deluxe rooms are definitely a class apart. Spaciously designed and flawlessly carved out super deluxe rooms area treat within itself.",
    // },
    // {
    //     room_id: 3,
    //     slug:"/RoomDetailsPage/3",
    //     roomName: "Sunset Room",
    //     roomImageData: [
    //         {
    //             roomImage:Sunset_Room_01,
    //         },
    //         {
    //             roomImage:Sunset_Room_02,
    //         },
    //         {
    //             roomImage:Sunset_Room_03,
    //         },
    //         {
    //             roomImage:Sunset_Room_04,
    //         },
    //         {
    //             roomImage:Sunset_Room_05,
    //         },
    //         {
    //             roomImage:Sunset_Room_06,
    //         },
    //         {
    //             roomImage:Sunset_Room_07,
    //         },
    //     ],
    //     roomPrice: "4,500",
    //     roomBed: "1",
    //     roomMax_Guests: "2",
    //     roomShort_Des:"The artistically carved out windows which serve as a wonderful coffee space ad the glimpse of setting sun from each self created picture frame is a Recommended",
    // },
    // {
    //     room_id: 4,
    //     slug:"/RoomDetailsPage/4",
    //     roomName: "Villa Room",
    //     roomImageData: [
    //         {
    //             roomImage:Villa_Room_01,
    //         },
    //         {
    //             roomImage:Villa_Room_02,
    //         },
    //         {
    //             roomImage:Villa_Room_03,
    //         },
    //         {
    //             roomImage:Villa_Room_04,
    //         },
    //         {
    //             roomImage:Villa_Room_05,
    //         },
    //     ],
    //     roomPrice: "6,000",
    //     roomBed: "2",
    //     roomMax_Guests: "5",
    //     roomShort_Des:"A Villa which is divided into 2 rooms each accommodates 5 adults with a balcony and a lawn for barbecue party.",
    // },
];

export default RoomData;